// extracted by mini-css-extract-plugin
export var cardIcon = "_1g-5";
export var cardIconUnframed = "_1g-9";
export var checkboxCard = "_1g-0";
export var checkboxCardSelected = "_1g-4";
export var disabled = "_1g-2";
export var interactive = "_1g-1";
export var outerBorder = "_1g-3";
export var spacerMedium = "_1g-8";
export var spacerSmall = "_1g-7";
export var spacerXsmall = "_1g-6";